import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { Today } from "./screens/Today";
import { Units } from "./screens/Units";
import { UnitDetail } from "./screens/UnitDetail";
import { SituationDetail } from "./screens/SituationDetail";
import { Work } from "./screens/Work";
import { Inbox } from "./screens/Inbox";
import { More } from "./screens/More";
import { InspectionFlow } from "./screens/inspection/InspectionFlow";
import { TourFlow } from "./screens/tour/TourFlow";
import { MoveOutFlow } from "./screens/moveout/MoveOutFlow";

export default function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Today />} />
        <Route path="/units" element={<Units />} />
        <Route path="/units/:unitId" element={<UnitDetail />} />
        <Route path="/situations/:situationId" element={<SituationDetail />} />
        <Route path="/work" element={<Work />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/more" element={<More />} />
        <Route path="/inspection/:inspectionId" element={<InspectionFlow />} />
        <Route path="/tour/:tourId" element={<TourFlow />} />
        <Route path="/moveout/:planId" element={<MoveOutFlow />} />
      </Route>
    </Routes>
  );
}
